import styled from "styled-components";

export const Title = styled.h1`
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px;
  margin: 35px 0 70px;
`;

export const ProfessorSearchForm = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 8%;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  border-radius: 8px;
  padding: 7px 12px;

  @media (min-width: 1080px) {
    width: calc(100% - 50px);
  }

  svg {
    height: 30px;
    width: 30px;
    margin-right: 8px;
    color: #f2f2f2;
  }

  input {
    color: #fff;
    background: transparent;
    border: 0;
    width: 100%;
    font-size: 16px;
  }
`;

export const PageProfessorContents = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

export const ContentItem = styled.div`
  text-decoration: none !important;
  width: 220px;
  height: 282px;
  margin-bottom: 5rem;
  cursor: pointer;

  @media (min-width: 768px) {
    margin: 5px;
  }
  @media (min-width: 1080px) {
    margin: 15px;
  }

  img {
    display: block;
    width: 215px;
    height: 282px;
  }

  span {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 25px;
    margin-left: 10px;
  }
`;
